import { Mail, Linkedin } from "lucide-react";
import tapLogo from "@/assets/tap-logo.png";

export default function Footer() {

  return (
    <footer className="relative bg-[#004aad] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Content */}
        <div className="py-12 sm:py-16 lg:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 xl:gap-20">
            
            {/* Left Side - Brand and Navigation */}
            <div className="space-y-8">
              {/* Brand */}
              <div className="flex items-center">
                <img 
                  src={tapLogo} 
                  alt="TAP Logo" 
                  className="h-6 sm:h-7 lg:h-8 w-auto object-contain"
                />
              </div>
              
              {/* Navigation Links */}
              <nav className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-1 gap-4 lg:gap-6">
                <a 
                  href="#home" 
                  className="group relative text-white/90 hover:text-orange-400 text-sm sm:text-base font-medium uppercase space-grotesk tracking-wide transition-all duration-300 ease-out hover:translate-x-1 block"
                >
                  <span className="relative z-10">HOME</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 transition-all duration-300 ease-out group-hover:w-full"></span>
                </a>
                <a 
                  href="#how-it-works" 
                  className="group relative text-white/90 hover:text-orange-400 text-sm sm:text-base font-medium uppercase space-grotesk tracking-wide transition-all duration-300 ease-out hover:translate-x-1 block"
                >
                  <span className="relative z-10">HOW IT WORKS</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 transition-all duration-300 ease-out group-hover:w-full"></span>
                </a>
                <a 
                  href="#why-airtalent" 
                  className="group relative text-white/90 hover:text-orange-400 text-sm sm:text-base font-medium uppercase space-grotesk tracking-wide transition-all duration-300 ease-out hover:translate-x-1 block"
                >
                  <span className="relative z-10">WHY AiRTALENT</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 transition-all duration-300 ease-out group-hover:w-full"></span>
                </a>
                <a 
                  href="#faq" 
                  className="group relative text-white/90 hover:text-orange-400 text-sm sm:text-base font-medium uppercase space-grotesk tracking-wide transition-all duration-300 ease-out hover:translate-x-1 block"
                >
                  <span className="relative z-10">FAQ</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 transition-all duration-300 ease-out group-hover:w-full"></span>
                </a>
                <a 
                  href="#contact" 
                  className="group relative text-white/90 hover:text-orange-400 text-sm sm:text-base font-medium uppercase space-grotesk tracking-wide transition-all duration-300 ease-out hover:translate-x-1 block"
                >
                  <span className="relative z-10">CONTACT</span>
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-orange-400 to-orange-500 transition-all duration-300 ease-out group-hover:w-full"></span>
                </a>
              </nav>
            </div>

            {/* Right Side - AiR Section */}
            <div className="space-y-8">
              
              {/* AiR Brand Section */}
              <div className="space-y-6">
                <div className="space-y-4">
                  <h2 className="text-white text-xl sm:text-2xl lg:text-3xl font-medium space-grotesk">
                    AiR
                  </h2>
                  <h4 className="text-white/90 text-base sm:text-lg font-medium space-grotesk">
                    Where Tech Meets Talent
                  </h4>
                  <div className="w-16 sm:w-20 h-1 bg-[#ff7a00]"></div>
                  <p className="text-white/80 text-sm sm:text-base leading-relaxed max-w-md">
                    Driving the future of recruitment by merging AI technology and expert knowledge to match great talent with ambitious organisations.
                  </p>
                </div>
                
                {/* Contact Information */}
                <div className="space-y-4">
                  <a 
                    href="mailto:contact@airtalent.co.uk" 
                    className="group flex items-center gap-3 transition-all duration-300 ease-out cursor-pointer w-fit"
                  >
                    <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-transparent group-hover:bg-orange-500 transition-all duration-300">
                      <div className="p-2 rounded-full bg-orange-500 group-hover:bg-white transition-all duration-300">
                        <Mail className="w-4 h-4 text-white group-hover:text-orange-500 transition-colors duration-300" />
                      </div>
                      <span className="text-white/80 text-sm sm:text-base group-hover:text-white group-hover:font-medium transition-all duration-300">
                        contact@airtalent.co.uk
                      </span>
                    </div>
                  </a>
                  
                  <a 
                    href="https://www.linkedin.com/showcase/air-tap" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="group flex items-center gap-3 transition-all duration-300 ease-out cursor-pointer w-fit"
                  >
                    <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-transparent group-hover:bg-orange-500 transition-all duration-300">
                      <div className="p-2 rounded-full bg-orange-500 group-hover:bg-white transition-all duration-300">
                        <Linkedin className="w-4 h-4 text-white group-hover:text-orange-500 transition-colors duration-300" />
                      </div>
                      <span className="text-white/80 text-sm sm:text-base group-hover:text-white group-hover:font-medium transition-all duration-300">
                        LinkedIn
                      </span>
                    </div>
                  </a>
                </div>
              </div>

            </div>

          </div>
        </div>
        
        {/* Copyright and Legal Section */}
        <div className="border-t border-white/20 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-6">
            {/* Copyright */}
            <div className="text-white/60 text-sm order-2 sm:order-1">
              <div className="space-y-1">
                <div>
                  <span>© 2025 </span>
                  <a 
                    href="https://airtalent.co.uk" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-white font-medium hover:text-orange-400 transition-colors duration-200"
                  >
                    AiR (AI Recruitment)
                  </a>
                  <span>. All rights reserved.</span>
                </div>
                <div className="text-white/50 text-xs">
                  Built with precision and passion for innovation.
                </div>
              </div>
            </div>
            
            {/* Legal Links */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-1 text-white/60 text-sm order-1 sm:order-2">
              <a 
                href="https://airtalent.co.uk/privacy-policy" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </a>
              <span className="hidden sm:inline mx-2">•</span>
              <a 
                href="https://airtalent.co.uk/terms-conditions" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
